<template>
  <b-row>
    <b-col md="3">
      <form-company action="update">
        <template #header>
          <h4 class="mb-4">Company Information</h4>
        </template>

        <template #submit-text>Save Changes</template>
      </form-company>
    </b-col>
    <b-col md="9">
      <div class="mb-4 d-flex align-items-center">
        <h4 class="mr-4 mb-0">Company Admins</h4>
        <a
          @click.prevent="
            $bus.$emit('toggle-modal', {
              key: 'company-admin',
              active: true
            })
          "
          href
          class="text-info text-xs"
          >Add Company Admin</a
        >
      </div>

      <TableCompanyAdmins />
      <ModalCompanyAdmin />
    </b-col>
  </b-row>
</template>

<script>
import Vue from 'vue'
import { defineComponent, onUnmounted } from '@vue/composition-api'
import { createVuexHelpers } from 'vue2-helpers'

import { useDOMPageTitle } from '@composables'
import FormCompany from '@components/FormCompany'
import TableCompanyAdmins from '@components/TableCompanyAdmins'
import ModalCompanyAdmin from '@components/ModalCompanyAdmin'

export default defineComponent({
  name: 'ManageCompanyProfile',
  components: {
    FormCompany,
    TableCompanyAdmins,
    ModalCompanyAdmin
  },
  setup(_, context) {
    const { setDOMPageTitle } = useDOMPageTitle()

    const { useGetters } = createVuexHelpers()

    const { company } = useGetters(['company'])

    setDOMPageTitle(company.value.name || '')

    onUnmounted(() => {
      Vue.prototype.$bus.destroyEvents()
    })

    return {}
  }
})
</script>
